import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isMultiDomains } from 'utils/isMultiDomain';
import config from 'utils/config';
import filterObject from 'utils/filterObject';
import { DefaultFormFieldLayout } from 'components/FormField';
import TitleCard from 'components/TitleCard';
import UnsavedChangesPrompt from 'components/UnsavedChangesPrompt';
import FormStack from 'components/FormStack';
import Stack from 'components/Stack';
import Hint from 'components/Hint';
import { formatTags, useHandleMultiSelectTags, AssetOwningTeamField, CompletionTimeField, LanguageField, MarkAsDoneModeField, TagField } from 'components/FormFields';
import { EditorPageStickySaveDiscardButton } from 'components/EditorPageStickyFooter';
import { useMultiAssetsForm } from './useMultiAssetsForm';
export function useIncludesScormCourses(items) {
  return useMemo(function () {
    return items.some(function (asset) {
      return asset.type === 'scorm';
    });
  }, [items]);
}
function getNewAssetTags(_ref) {
  var asset = _ref.asset,
    tagsToAdd = _ref.tagsToAdd,
    tagsToRemove = _ref.tagsToRemove;
  if (!tagsToAdd.length && !tagsToRemove.length) {
    return undefined;
  }
  var currentTags = asset.tags || [];
  var tagsToAddCleaned = tagsToAdd.filter(function (tag) {
    return !currentTags.some(function (t) {
      return t.id === tag.id;
    });
  });
  var updatedTags = [].concat(_toConsumableArray(currentTags), _toConsumableArray(tagsToAddCleaned)).filter(function (tag) {
    return !tagsToRemove.some(function (removeTag) {
      return removeTag.id === tag.id;
    });
  });
  return updatedTags;
}
function MultiAssetDetailsPage(_ref2) {
  var initialAssetDetailItems = _ref2.initialAssetDetailItems,
    onSubmit = _ref2.onSubmit,
    onClose = _ref2.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmissionLoading = _useState2[0],
    setIsSubmissionLoading = _useState2[1];
  var assetIds = initialAssetDetailItems.map(function (asset) {
    return asset.id;
  });
  var domainIds = initialAssetDetailItems.map(function (asset) {
    return asset.domain_id;
  });
  var containsDistributed = isMultiDomains(domainIds);
  var includesScormCourses = useIncludesScormCourses(initialAssetDetailItems);
  var _useHandleMultiSelect = useHandleMultiSelectTags({
      initialContentItems: initialAssetDetailItems,
      contentIds: assetIds
    }),
    wereTagsChanged = _useHandleMultiSelect.wereTagsChanged,
    selectedTags = _useHandleMultiSelect.selectedTags,
    tagsToRemove = _useHandleMultiSelect.tagsToRemove,
    tagsToAdd = _useHandleMultiSelect.tagsToAdd,
    addTag = _useHandleMultiSelect.addTag,
    removeTag = _useHandleMultiSelect.removeTag,
    resetTags = _useHandleMultiSelect.resetTags;
  var assetForm = useMultiAssetsForm({
    assets: initialAssetDetailItems
  });
  var fields = assetForm.fields,
    hasErrors = assetForm.hasErrors,
    wasChanged = assetForm.wasChanged,
    reset = assetForm.reset;
  var hasChanges = wasChanged || wereTagsChanged;
  function resetAll() {
    reset();
    resetTags();
  }
  function formatPayload() {
    var _fields$ownerTeamIds$, _fields$ownerTeamIds$2;
    var contentData = {
      locale: fields.locale.changedValue,
      completionTime: fields.completionTime.wasChanged ? Number(fields.completionTime.value) : undefined,
      markAsDoneMode: fields.markAsDoneMode.changedValue !== 'mixed' ? fields.markAsDoneMode.changedValue : undefined,
      ownerTeamId: (_fields$ownerTeamIds$ = (_fields$ownerTeamIds$2 = fields.ownerTeamIds.changedValue) === null || _fields$ownerTeamIds$2 === void 0 ? void 0 : _fields$ownerTeamIds$2[0]) !== null && _fields$ownerTeamIds$ !== void 0 ? _fields$ownerTeamIds$ : undefined
    };
    var payload = [];
    initialAssetDetailItems.forEach(function (asset) {
      var tags = getNewAssetTags({
        asset: asset,
        tagsToAdd: tagsToAdd,
        tagsToRemove: tagsToRemove
      });
      payload.push({
        changes: filterObject(_objectSpread(_objectSpread({}, contentData), {}, {
          tags: tags
        })),
        id: asset.id
      });
    });
    return payload;
  }
  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            setIsSubmissionLoading(true);
            _context.prev = 2;
            _context.next = 5;
            return onSubmit(formatPayload());
          case 5:
            resetAll();
            onClose();
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
            setIsSubmissionLoading(false);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 9]]);
    }));
    return function handleSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(UnsavedChangesPrompt, {
    hasUnsavedChanges: hasChanges,
    includeQueryParams: true
  }), /*#__PURE__*/React.createElement(Stack, {
    spacing: "m"
  }, /*#__PURE__*/React.createElement(TitleCard, {
    variant: "raised",
    title: t('actions_edit_asset_plural', {
      count: assetIds.length
    })
  }, /*#__PURE__*/React.createElement(DefaultFormFieldLayout, {
    horizontal: true
  }, /*#__PURE__*/React.createElement(FormStack, {
    spacing: "l"
  }, containsDistributed && /*#__PURE__*/React.createElement(Hint, {
    icon: "share"
  }, t('immutability_note_selection_contains_distributed_asset_fields')), /*#__PURE__*/React.createElement(TagField, {
    isMultiSelect: true,
    contentType: "asset",
    selectedTags: formatTags(selectedTags),
    onChangeSelectedTags: function onChangeSelectedTags(data) {
      addTag(data.itemsToAdd);
      removeTag(data.itemsToRemove);
    },
    isDisabled: containsDistributed
  }), config.assetLanguageEnabled && /*#__PURE__*/React.createElement(LanguageField, {
    value: fields.locale.value,
    onChange: function onChange(newPlaylistLocale) {
      return fields.locale.set(newPlaylistLocale);
    },
    isDisabled: containsDistributed
  }), /*#__PURE__*/React.createElement(CompletionTimeField, {
    completionTime: fields.completionTime.value !== undefined && fields.completionTime.value !== null ? Number(fields.completionTime.value) : undefined,
    onChange: function onChange(e) {
      return fields.completionTime.set(Number(e.target.value));
    },
    isDisabled: containsDistributed
  })))), /*#__PURE__*/React.createElement(TitleCard, {
    variant: "raised",
    title: t('menu_advanced_settings')
  }, /*#__PURE__*/React.createElement(DefaultFormFieldLayout, {
    horizontal: true
  }, /*#__PURE__*/React.createElement(FormStack, {
    spacing: "m"
  }, config.autoMarkAsDone && /*#__PURE__*/React.createElement(MarkAsDoneModeField, {
    isMultiSelect: true,
    isScormCourse: includesScormCourses,
    initialMode: fields.markAsDoneMode.defaultValue,
    mode: fields.markAsDoneMode.value,
    resetMarkAsDoneMode: fields.markAsDoneMode.reset,
    onChange: function onChange(newMode) {
      var _fields$markAsDoneMod;
      return (_fields$markAsDoneMod = fields.markAsDoneMode) === null || _fields$markAsDoneMod === void 0 ? void 0 : _fields$markAsDoneMod.set(newMode);
    }
  }), !containsDistributed && config.managersCreateAssets && /*#__PURE__*/React.createElement(AssetOwningTeamField, {
    values: fields.ownerTeamIds.value,
    defaultOwnerTeamIds: fields.ownerTeamIds.defaultValue,
    contentIds: assetIds,
    onChange: function onChange(ownerTeamIds) {
      return fields.ownerTeamIds.set(ownerTeamIds);
    }
  }))))), /*#__PURE__*/React.createElement(EditorPageStickySaveDiscardButton, {
    hasChanges: hasChanges,
    isDisabled: hasErrors,
    isSaving: isSubmissionLoading,
    onDiscard: resetAll,
    buttonText: t('actions_done'),
    cardVariant: "raised"
  }));
}
export default MultiAssetDetailsPage;